<template>
  <div class="addinformation">
    <el-form
      :model="informationForm"
      :rules="newsRules"
      ref="informationForm"
      class="demo-informationForm"
      label-position="left"
    >
      <el-form-item label="消息公告图标：" prop="icon">
        <upload-img
          :fixedNumber="[1, 1]"
          fixedName="1:1"
          accept="image/*"
          tip="只支持 1:1 尺寸"
          uploadName="上传图标"
          @uploadInfo="uploadInfo"
          :fixedFlag="true"
          fileDir="information"
          :resultImg="informationForm.icon"
        />
      </el-form-item>
      <el-form-item label="消息公告标题：" prop="title">
        <el-input
          show-word-limit
          maxlength="25"
          v-model="informationForm.title"
          placeholder="请输入消息公告标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="消息公告内容：" prop="title">
        <el-input
          show-word-limit
          maxlength="300"
          v-model="informationForm.content"
          placeholder="请输入消息公告内容"
          type="textarea"
          :rows="3"
        ></el-input>
      </el-form-item>
      <el-form-item label="跳转类型：" prop="jumpType">
        <el-select
          v-model="informationForm.jumpType"
          placeholder="请选择跳转类型"
        >
          <el-option
            v-for="item in getDictDatas(DICT_TYPE.JUMP_TYPE)"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="跳转参数："
        prop="parameter"
        v-if="informationForm.jumpType !== 0"
      >
        <el-input
          v-model="informationForm.parameter"
          placeholder="请输入跳转参数"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否启用：">
        <el-switch v-model="informationForm.status"></el-switch>
      </el-form-item>
      <el-form-item class="handlebox">
        <el-button
          type="primary"
          @click="submitForm('informationForm')"
          class="enter-btn save-btn"
          :loading="submitLoading"
          >保存</el-button
        >
        <el-button
          @click="resetForm('informationForm')"
          class="cancel-btn calloff-btn"
          >取消</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
// import { uploadOss } from "@/api/login";
import { setInfo, getInfoDetais } from "@/api/home";
import UploadImg from "../../../components/UploadImg";
export default {
  name: "addarticle",
  components: {
    UploadImg,
  },
  data() {
    return {
      id: null,
      informationForm: {
        title: "", // 消息公告标题
        jumpType: "", //消息公告跳转类型
        parameter: "", //跳转参数
        status: false, //是否启用
        icon: "", //消息公告封面
        content: "", //消息公告内容
      },
      newsRules: {
        title: [
          { required: true, message: "请输入消息公告标题", trigger: "blur" },
          {},
        ],
        jumpType: [
          {
            required: true,
            message: "请选择消息公告跳转类型",
            trigger: "change",
          },
        ],
        parameter: [
          { required: true, message: "请输入跳转参数", trigger: "blur" },
        ],
        icon: [
          { required: true, message: "请上传消息公告图标", trigger: "change" },
        ],
      },
      submitLoading: false,
      type: "add",
    };
  },
  async created() {
    this.type = this.$route.query.type;
    this.id = this.$route.query.id;
    if (this.type === "edit") {
      const res = await getInfoDetais({ id: this.id });
      this.informationForm = res.result;
      this.informationForm.status =
        this.informationForm.status === 1 ? false : true;
      // console.log(this.informationForm);
    }
  },
  mounted() {},
  computed: {},
  methods: {
    // 获取上传封面
    uploadInfo(info) {
      this.informationForm.icon = info;
    },
    // 新建资讯
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          this.submitLoading = true;
          if (this.type === "add") {
            const params = this.informationForm;
            params.status = this.informationForm.status ? 0 : 1;
            await setInfo(params);
            this.$message.success("添加成功！");
            this.$router.go(-1);
          } else {
            const { id, icon, content, jumpType, parameter, status, title } =
              this.informationForm;
            const params = {
              id,
              icon,
              content,
              jumpType,
              parameter,
              status: status ? 0 : 1,
              title,
            };
            await setInfo(params);
            this.$message.success("修改成功！");
            this.$router.go(-1);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm() {
      // this.$refs[formName].resetFields();
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.addinformation {
  ::v-deep .demo-informationForm {
    .el-form-item__label {
      white-space: nowrap;
      min-width: 120px;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
    }
    .el-input {
      width: 380px;
    }
    .el-textarea {
      width: 50vw;
    }
  }
  .newscontent {
    display: flex;
    span {
      display: block;
      font-weight: 400;
      font-size: 14px;
      color: #262626;
      line-height: 20px;
      min-width: 120px;
    }
  }
  .handlebox {
    margin: 50px 0 0 120px;
  }
}
</style>
<style>
p {
  margin: 10px;
}

.edit_container,
.quill-editor {
  height: 300px;
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14" !important;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="14px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="14px"]::before {
  content: "14" !important;
  font-size: 14px;
}

.ql-size-14px {
  font-size: 14px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="16px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="16px"]::before {
  content: "16" !important;
  font-size: 16px;
}

.ql-size-16px {
  font-size: 16px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="18px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="18px"]::before {
  content: "18" !important;
  font-size: 18px;
}

.ql-size-18px {
  font-size: 18px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="20px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="20px"]::before {
  content: "20" !important;
  font-size: 20px;
}

.ql-size-20px {
  font-size: 20px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="22px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="22px"]::before {
  content: "22" !important;
  font-size: 22px;
}

.ql-size-22px {
  font-size: 22px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="26px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="26px"]::before {
  content: "26" !important;
  font-size: 26px;
}

.ql-size-26px {
  font-size: 26px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="28px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="28px"]::before {
  content: "28" !important;
  font-size: 28px;
}

.ql-size-28px {
  font-size: 28px;
}

.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="30px"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="30px"]::before {
  content: "30" !important;
  font-size: 30px;
}

.ql-size-30px {
  font-size: 30px;
}
</style>
